import _ from 'lodash';
import React, { Component } from 'react';

const DEFAULT_COLOR = '#545B72';

class ScoreProgress extends Component {

  renderTensMarkers(){

    const { score } = this.props;

    const isFilled = (val) => {
      return val * 5 <= score;
    }

    return (
      <div className="markers">
        {_.map([1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18, 19], (val) => (<div key={val} className={`marker ${isFilled(val) ? 'filled' : ''}`}></div>))}
      </div>
    )
  }

  render(){

    const {
      className,
      score,
      priorScore,
      teamAvg,
      delta,
      color,
    } = this.props;

    return (
      <div className="score-progress capped-width">
        <div className="progress-container">
          {this.renderTensMarkers()}
          <div className="progress" style={{ width: `${score}%`, backgroundColor: color || DEFAULT_COLOR }}>
            <div className="score-value" style={{ backgroundColor: color || DEFAULT_COLOR }}>{score}<div className="triangle" style={{ borderTopColor: color || DEFAULT_COLOR }}></div></div>
          </div>
          <div className="benchmarks">
            {priorScore &&
              <div className="benchmark" style={{ width: `${priorScore}%` }}>
                <div className="score-value">{priorScore} <small>Prior Score</small></div>
              </div>
            }
            {teamAvg &&
              <div className="benchmark" style={{ width: `${priorScore}%` }}>
                <div className="score-value">{teamAvg} <small>(Team Avg)</small></div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ScoreProgress;



// WEBPACK FOOTER //
// ./src/components/shared/scoreProgress.js